module.exports = __webpack_public_path__ + "assets/ic_tree19.fe1029d0.svg";